import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-check-email',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './check-email.component.html',
  styleUrls: ['./check-email.component.scss'],
  host: { 'class': 'w-full block' }
})
export class CheckEmailComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private countdownTimer: ReturnType<typeof setInterval> | null = null;
  
  type: 'reset-password' | 'signup' = 'reset-password';
  email: string = '';
  resendStatus: 'idle' | 'sending' | 'sent' | 'error' = 'idle';
  cooldown = 0;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.type = params['type'] || 'reset-password';
      this.email = params['email'] || '';
    });
  }

  ngOnDestroy(): void {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }

  resend(): void {
    if (!this.email || this.resendStatus === 'sending' || this.cooldown > 0) return;
    
    this.resendStatus = 'sending';
    
    const request$ = this.type === 'signup'
      ? this.authService.resendActivation(this.email)
      : this.authService.resetPasswordRequest(this.email);

    request$.subscribe({
      next: () => {
        this.resendStatus = 'sent';
        this.startCooldown();
      },
      error: () => {
        this.resendStatus = 'error';
      }
    });
  }

  private startCooldown(): void {
    this.cooldown = 60;
    this.countdownTimer = setInterval(() => {
      this.cooldown--;
      if (this.cooldown <= 0) {
        clearInterval(this.countdownTimer!);
        this.countdownTimer = null;
        this.resendStatus = 'idle';
      }
    }, 1000);
  }
}
